import type {
  IconName,
  IconPrefix,
} from '@fortawesome/fontawesome-common-types';
import type { SxProps } from '@mui/material';
import { IconButton as MuiIconButton, Tooltip } from '@mui/material';
import type { IconButtonProps as MuiIconButtonProps } from '@mui/material';
import type { MouseEvent, MouseEventHandler } from 'react';
import React from 'react';

import Icon from '@components/Icon/Icon';

export interface IconButtonProps {
  disabled?: boolean;
  onClick: MouseEventHandler;
  name: IconName;
  tooltip?: string;
  size?: number;
  color?: string;
  iconType?: IconPrefix;
  sx?: SxProps;
  iconButtonProps?: MuiIconButtonProps;
  rotation?: number;
  'data-testid'?: string;
}

export default function IconButton({
  name,
  onClick,
  tooltip,
  size = 16,
  color,
  iconType = 'fat',
  sx,
  disabled = false,
  iconButtonProps,
  rotation,
  'data-testid': dataTestId,
}: IconButtonProps) {
  const handleClick = (event: MouseEvent) => {
    if (disabled) {
      return;
    }
    event.stopPropagation();
    onClick(event);
  };

  return (
    <Tooltip title={tooltip}>
      <span>
        <MuiIconButton
          edge="end"
          disabled={disabled}
          data-testid={dataTestId}
          {...iconButtonProps}
          onClick={handleClick}
          sx={{
            fontSize: size,
            height: 'fit-content',
            width: 'fit-content',
            margin: 'auto',
            ...sx,
          }}
        >
          <Icon color={color} name={name} rotation={rotation} type={iconType} />
        </MuiIconButton>
      </span>
    </Tooltip>
  );
}
